import { createFromIconfontCN } from '@ant-design/icons';

const Icons = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3253809_483vkp5kwy7.js', // 在 iconfont.cn 上生成
});
export default Icons
